module.exports = __webpack_public_path__ + "img/code.a94150b3.png";